import { create } from "zustand"
import { FormInput } from './types'

type FormStore = {
  data: Partial<FormInput>
  setData: (data: Partial<FormInput>) => void
  reset: () => void
}

export const useFormStore = create<FormStore>((set) => ({
  data: {},
  errors: {},
  setData: (data) =>  set({ data }),
  reset: () => set({ data: {} }),
}))